<template>
  <div :class="(error) ? 'input-field text-danger' : 'input-field'">
    <label v-if="label" class="active" :for="textareaId">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>

    <textarea
        ref="taRef"
        :class="[
          'form-control',
          error ? 'is-invalid' : ''
        ]"
        :id="textareaId"
        :value="modelValue"
        :placeholder="placeholder"
        :rows="rows"
        :disabled="disabled"
        :readonly="readonly"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @input="updateValue"
    />

    <p v-if="error" class="text-danger mt-0">{{ error }}</p>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits } from "vue";
  import { v4 as uuidv4 } from 'uuid';
  import { ref, watch, nextTick } from "vue";

  const props = defineProps({
    modelValue: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    rows: {
      type: Number,
      default: 4
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    error: String
  });

  const emit = defineEmits(["update:modelValue", "focus", "blur"]);
  const textareaId = uuidv4();
  const taRef = ref(null);

  function updateValue(event) {
    emit("update:modelValue", event.target.value);
  }

  // Watch autoFocus prop
  watch(
      () => props.autoFocus,
      async (newVal) => {
        if (newVal) {
          setTimeout(() => {
            nextTick(); // wait until element is in the DOM
            taRef.value?.focus();
          }, 0);
        }
      },
      { immediate: true } // focus on mount if autoFocus is true
  );
</script>
